module.exports = (s) => {
  return [
    {
      name: '媒体',
      value: 'type',
      fixed: true,
    },
    {
      name: '广告主名称',
      value: 'advertiser_name',
      fixed: true,
    },
    {
      name: '广告主ID',
      value: 'advertiser_id',
      fixed: true,
    },
    {
      name: '媒体账户备注',
      value: 'note',
    },
    {
      name: '负责人',
      value: 'contacter',
    },
    {
      name: '账户余额',
      value: 'cash',
    },
    {
      name: '账户余额告警',
      value: 'cash_warm',
    },
    {
      name: '今日消耗',
      value: 'today_cost',
    },
    {
      name: '昨日消耗',
      value: 'yesterday_cost',
    },
    {
      name: '媒体返点',
      value: 'rebate',
    },
    {
      name: '状态',
      value: 'status',
    },
    {
      name: '操作',
      fixed: 'right',
      width: 380,
      format: (row) => {
        const h = s.$createElement;
        const ele = h('div',
          null, [
            h('el-button', {
              props: { size: 'mini', type: 'primary' },
              on: {
                click: () => {
                  s.editNote(row);
                },
              },
            }, '修改'),
            h('el-button', {
              props: { size: 'mini', type: 'primary' },
              on: {
                click: () => {
                  s.editRebate(row);
                },
              },
            }, '设置返点'),
            h('el-button', {
              props: { size: 'mini', type: 'primary' },
              on: {
                click: () => {
                  const { app_id, advertiser_id } = row;
                  s.refreshToken(app_id, advertiser_id);
                },
              },
            }, '刷新Token'),
            h('el-button', {
              props: { size: 'mini', type: 'primary' },
              on: {
                click: () => {
                  const { advertiser_id } = row;
                  s.testToken(advertiser_id);
                },
              },
            }, '测试Token'),
          ]
        );
        return ele;
      },
    },
  ];
};
